import { FMSType, TenantInfo } from '../FMS/FMS.Interfaces'

export enum FMSTenantCrons {
  MoveIn = 'Move In',
  MoveOut = 'Move Out',
  MoveInPlusOne = 'Move In Plus One',
  MoveInPlus90 = 'Move In Plus 90',
  AutoPay = 'Auto Pay',
  PaymentDue = 'Payment Due',
  PaymentPastDue = 'Payment Past Due',
  PaymentLate = 'Payment Late',
  OutOfDateContactInfo = 'Out of Date Contact Info',
  OutOfDateBillingInfo = 'Out of Date Billing Info',
  ExpiringPaymentMethod = 'Expiring Payment Method'
}

export const FMSCronNamesMap = {
  [FMSTenantCrons.MoveIn]: {
    quest: '💎 FMS Automation: Move - In Start',
    questSlug: 'fms-automation-move-in',
    smsGroupSlug: 'fms-automation-move-in',
    group: 'FMS Automation: Move - In'
  },
  [FMSTenantCrons.MoveInPlusOne]: {
    quest: '💎 FMS Automation: Move In Plus One Start',
    questSlug: 'fms-automation-move-in-plus-one',
    smsGroupSlug: 'fms-automation-move-in-plus-one',
    group: 'FMS Automation: Move In Plus One'
  },
  [FMSTenantCrons.MoveInPlus90]: {
    quest: '💎 FMS Automation: Move In Plus 90 Start',
    questSlug: 'fms-automation-move-in-plus-90',
    smsGroupSlug: 'fms-automation-move-in-plus-90',
    group: 'FMS Automation: Move In Plus 90'
  },
  [FMSTenantCrons.MoveOut]: {
    quest: '💎 FMS Automation: Move - Out Start',
    questSlug: 'fms-automation-move-out',
    smsGroupSlug: 'fms-automation-move-out',
    group: 'FMS Automation: Move - Out'
  },
  [FMSTenantCrons.AutoPay]: {
    quest: '💎 FMS Automation: Auto Pay Upcoming Start',
    questSlug: 'fms-automation-auto-pay-upcoming',
    smsGroupSlug: 'fms-automation-auto-pay-upcoming',
    group: 'FMS Automation: Auto Pay Upcoming'
  },
  [FMSTenantCrons.PaymentDue]: {
    quest: '💎 FMS Automation: Payment Due Upcoming Start',
    questSlug: 'fms-automation-payment-due-upcoming',
    smsGroupSlug: 'fms-automation-payment-due-upcoming',
    group: 'FMS Automation: Payment Due Upcoming'
  },
  [FMSTenantCrons.PaymentPastDue]: {
    quest: '💎 FMS Automation: Payment Past Due Start',
    questSlug: 'fms-automation-payment-past-due',
    smsGroupSlug: 'fms-automation-payment-past-due',
    group: 'FMS Automation: Payment Past Due'
  },
  [FMSTenantCrons.PaymentLate]: {
    quest: '💎 FMS Automation: Late Payment Start',
    questSlug: 'fms-automation-late-payment',
    smsGroupSlug: 'fms-automation-late-payment',
    group: 'FMS Automation: Late Payment'
  },
  [FMSTenantCrons.OutOfDateContactInfo]: {
    quest: '💎 FMS Automation: Confirm Contact Info Start',
    questSlug: 'fms-automation-confirm-contact-info',
    smsGroupSlug: 'fms-automation-confirm-contact-info',
    group: 'FMS Automation: Confirm Contact Info'
  },
  [FMSTenantCrons.OutOfDateBillingInfo]: {
    quest: '💎 FMS Automation: Confirm Billing Info Start',
    questSlug: 'fms-automation-confirm-billing-info',
    smsGroupSlug: 'fms-automation-confirm-billing-info',
    group: 'FMS Automation: Confirm Billing Info'
  },
  [FMSTenantCrons.ExpiringPaymentMethod]: {
    quest: '💎 FMS Automation: Expiring Payment Method Upcoming Start',
    questSlug: 'fms-automation-expiring-payment-method-upcoming',
    smsGroupSlug: 'fms-automation-expiring-payment-method-upcoming',
    group: 'FMS Automation: Expiring Payment Method Upcoming'
  }
}

// FMS Automation: Auto Pay Upcoming Start
// FMS Automation: Payment Due Upcoming Start
// FMS Automation: Payment Past Due Start
// FMS Automation: Late Payment Start
// FMS Automation: Payment Successful Start
// FMS Automation: Confirm Contact Info Start
// FMS Automation: Confirm Billing Info Start
// FMS Automation: Expiring Payment Method Upcoming Start
export enum CronEnvironment {
  PRODUCTION = 'PRODUCTION',
  STAGING = 'STAGING',
  DEVELOPMENT = 'DEVELOPMENT'
}

export interface FMSLocationCronJobResults {
  fms: FMSType
  facilityId: string
  day: string
  createdAt: Date
  environment?: CronEnvironment
  errors?: string[]
  [FMSTenantCrons.MoveIn]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.MoveInPlusOne]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.MoveInPlus90]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.MoveOut]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.AutoPay]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.PaymentDue]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.PaymentPastDue]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.PaymentLate]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.OutOfDateContactInfo]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.OutOfDateBillingInfo]?: { count: number; users: TenantInfo[] }
  [FMSTenantCrons.ExpiringPaymentMethod]?: { count: number; users: TenantInfo[] }
}

export enum FMSCronErrorScope {
  LOCATION = 'location',
  TENANT = 'tenant'
}
